<div class="project-page">
  <header class="project-header">
    <p class="eyebrow">Endless Blow :: Account</p>
    <h1>Reset your password</h1>
    <p class="intro">Choose a new password for your Endless Blow account.</p>
  </header>

  <section class="reset-card">
    <p class="error-msg" *ngIf="tokenFromUrl===undefined || tokenFromUrl.length!==30">
      This request does not come from the game.
    </p>

    <form (ngSubmit)="submitFunc()" [formGroup]="changePasswordForm"
          *ngIf="tokenFromUrl!==undefined && tokenFromUrl.length===30">
      <label for="password">New password</label>
      <input type="password" name="password" formControlName="password" id="password"
             placeholder="Enter new password" required autofocus>
      <div class="error-msg" *ngIf="changePasswordForm.controls['password'].invalid">
        Password must be at least 6 characters
      </div>

      <label for="confirmPassword">Confirm password</label>
      <input type="password" name="confirmPassword" formControlName="confirmPassword"
             id="confirmPassword" placeholder="Confirm new password">
      <div class="error-msg" *ngIf="changePasswordForm.controls['confirmPassword'].invalid">
        Passwords must match
      </div>
      <div class="error-msg" *ngIf="changePasswordForm.controls.confirmPassword.errors?.required">
        Password is required
      </div>

      <button type="submit">Change password</button>
      <p class="status-message">{{waitForResponse}}</p>
      <p class="status-message">{{data}}</p>
    </form>
  </section>
</div>
